import type { ReactNode } from 'react';

export type NavEntryGroup = {
    icon: ReactNode;
    title: string;
    entries: NavEntryItem[];
};

export type NavEntryItem = {
    icon: ReactNode;
    path: string;
    title: string;
    permissionsRequired: string[];
    disabled?: boolean;
    external?: boolean;
    exact?: boolean;
};

export type SidebarEntry = NavEntryGroup | NavEntryItem;

export function isOfTypeNavEntryGroup(
    toBeDetermined: SidebarEntry
): toBeDetermined is NavEntryGroup {
    return typeof (toBeDetermined as NavEntryGroup).entries !== 'undefined';
}

export function getPathnamesOfItems(items: SidebarEntry[]): string[] {
    const pathnames: string[] = [];
    for (const item of items) {
        if (isOfTypeNavEntryGroup(item)) {
            for (const entry of item.entries) {
                pathnames.push(entry.path);
            }
        } else {
            pathnames.push(item.path);
        }
    }
    return pathnames;
}
